module.exports = __webpack_public_path__ + "static/media/people.0f37f182.svg";